export default __webpack_public_path__ + "static/bookcover_200-e996857ce35dbeb7acc1ca7a39b19401.jpg";